import axios from "axios";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast, ToastContainer } from "react-toastify";

const FormContainer = styled.form`
  min-width: 800px;
  background-color: #fff;
  padding: 20px 20px;
  box-shadow: 0px 0px 2px #ccc;
  border-radius: 0.5px;
  margin: 0 auto; 
  flex-direction: row;

`;

const Div = styled.td`
  display: flex;
  flex-direction: row;
  justify-content: center;
`;

const InputArea = styled.div`
  width: auto;
  display: flex;
  flex-direction: column;
  padding: 10px;

  select {
    width: 250px;
    padding: 0 10px;
    border: 1px solid #bbb;
    border-radius: 1px;
    height: 37px;
  }



`;

const Input = styled.input`
  width: 200px;
  padding: 0 10px;
  border: 1px solid #bbb;
  border-radius: 1px;
  height: 37px;

  
`;



const Label = styled.label`
  color: #4f4f4f;
  font-weight: bold;
  font-size: 17px;  
`;






const Div2 = styled.td`
  display: flex;
  flex-direction:row;
 
`;


export const Tr = styled.tr`
  text-align: center;

`;
export const Td = styled.td`
  word-break: break-word;
  padding: 15px 2px 5px 2px;
  width: 250px;
  text-align: ${(props) => (props.alignCenter ? "center" : "start")};

  select {
    margin-right: 5px;
  }
 
`;

const Table = styled.table`
  width: 98%;
  padding: 20px 20px;
  margin-top: 30px;
`;

export const Th = styled.th`
  color: #4f4f4f;
  text-align: start;
  border-bottom: inset;
  padding-bottom: 5px;

`;

const Form = ({ urlApi, pagina, modulo, acesso, fetchAcesso, editarUsuario }) => {

  // tokens
  const token = localStorage.getItem('token');


  //------------------------------MAPEANDO PARA MONTAR O FORMULARIO----------------------------------//
  const moduloMap = modulo.reduce((acc, mod) => {
    acc[String(mod.ID_MODULO)] = mod.DESC_MODULO;
    return acc;
  }, {});

  const groupedPages = pagina.reduce((acc, item) => {
    const key = String(item.ID_MODULO);
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(item);
    return acc;
  }, {});

  const modulosComPaginas = Object.keys(groupedPages).map((ID_MODULO) => ({
    ID_MODULO,
    desc_modulo: moduloMap[ID_MODULO] || "Módulo não encontrado",
    paginas: groupedPages[ID_MODULO],
  }));




  //----------------------------------STATE PARA EDITAR USUARIO--------------------------------------------//

  //editarUsuario que vem do Grid para ser editado
  const [login, setLogin] = useState("");
  const [nome, setNome] = useState("");
  const [isModified, setIsModified] = useState("")
  useEffect(() => {
    if (editarUsuario) {
      setLogin(editarUsuario.LOGON || "");
      setNome(editarUsuario.NOME || "");
    }
  }, [editarUsuario]);


  //-----------------------------MAPEIA OS ACESSOS QUE O USUÀRIO JÀ TEM-------------------------------------//

  const getSelectedStatus = (id_pagina) => {
    if (!editarUsuario) return 'N';

    const acessoUsuario = acesso.find(
      (a) =>
        a.COD_FUNCIONARIO === editarUsuario.COD_FUNCIONARIO &&
        a.ID_PAGINA === id_pagina
    );

    return acessoUsuario ? acessoUsuario.STATUS : 'N';
  };



  //-----------------------------SALVA AS INFORMAÇÔES NO BANCO------------------------------------------//

  const [selectedPages, setSelectedPages] = useState({});
  const handleSelectChange = async (id_pagina, id_modulo, value) => {
    const data = {
      id_usuario: editarUsuario.COD_FUNCIONARIO,
      id_modulo,
      id_pagina,
      status: value,
    };

    const config = {
      headers: { Authorization: `Bearer ${token}` },
    };

    try {
      if (value === 'N') {
        await axios.request({
          method: 'delete',
          url: `${urlApi}gestao/acessos`,
          data,
          ...config,
        });
        toast.success("Acesso removido com sucesso.");

        fetchAcesso();
      } else {
        await axios.post(`${urlApi}gestao/acessos`, data, config);
        toast.success("Acesso concedido com sucesso.");
      }


    } catch (err) {
      console.error('Erro ao atualizar acesso:', err);
      toast.error("Erro ao atualizar acesso.");
    }

    setSelectedPages((prev) => ({
      ...prev,
      [id_pagina]: value,
    }));

    fetchAcesso();
  };








  return (
    <>
      {editarUsuario && (
        <FormContainer >
          <Div>
            <Div2>
              <InputArea>
                <Label>Login:</Label>
                <Input name="login" type="text" value={login} onChange={(e) => setLogin(e.target.value)} readOnly />
              </InputArea>
              <InputArea>
                <Label>Nome:</Label>
                <Input name="nome" type="text" value={nome} onChange={(e) => setNome(e.target.value)} readOnly />
              </InputArea>
            </Div2>


          </Div>

          <Table>
            <thead>
              <Tr>
                {modulosComPaginas.map((mod) => (
                  <Th key={mod.ID_MODULO}>{mod.desc_modulo}</Th>
                ))}
              </Tr>
            </thead>
            <tbody>
              <Tr>
                {modulosComPaginas.map((mod) => (
                  <Td key={mod.ID_MODULO}>
                    {mod.paginas.map((pagina) => (
                      <div key={pagina.ID_PAGINA} style={{ marginBottom: 8 }}>
                        <select
                          value={getSelectedStatus(pagina.ID_PAGINA)}
                          onChange={(e) =>
                            handleSelectChange(
                              pagina.ID_PAGINA,
                              mod.ID_MODULO,
                              e.target.value
                            )
                          }
                        >
                          <option value="S">Sim</option>
                          <option value="N">Não</option>
                        </select>
                        <span style={{ marginLeft: 8 }}>{pagina.DESC_PAGINA}</span>
                      </div>
                    ))}
                  </Td>
                ))}


              </Tr>
            </tbody>
          </Table>



          <ToastContainer autoClose={2500} position={toast.POSITION.BOTTOM_LEFT} style={{ width: '400px', fontSize: '22px' }} />
        </FormContainer>

      )}
      <style jsx global>{`
      .swal2-container.custom-swal-container {
        z-index: 9999; 
      }
    `}</style>
    </>
  );
};

export default Form;


